<template>
  <div class="star-project-container">
    <div class="star-project-wrap collapse-item" ref="starProject">
      <div class="top">
        <i
          class="icon iconfont iconicon_arrow_task activeIconHover"
          :class="{'is-hidden': starHide}"
          @click="hadnleHideAndShow('starHide', 'starProject')"
        ></i>
        <p>星标项目</p>
      </div>
      <div
        class="star-project-content content-wrap"
        v-infinite-scroll="load"
        :class="{ 'no-item': !starProjectList.length }"
      >
        <Nothing
          v-if="!starProjectList.length"
          :config="{
            tip: '暂无星标项目'
          }"
        ></Nothing>
        <vuedraggable v-else class="star-project-box"  handle=".task-drag-box-icon" element="div" v-bind="dragOptions()"  :list="starProjectList" @update="end" @add="end">
          <Project-item
            v-for="item in starProjectList"
            :key="item.project_id"
            :depId="item.project_depart_id"
            :disabled="!item.permissions"
            :projectInfo="item"
            :data-id="item.project_id"
            @click.native="handleTo(item.project_id)"
            @starSuccess="getStarListReset()"
          >
          </Project-item>
        </vuedraggable>
      </div>
    </div>
    <div class="update-history-project-wrap">
      <div class="update-project-wrap collapse-item" ref="updateProject">
        <div class="top">
          <i
            class="icon iconfont iconicon_arrow_task activeIconHover"
            :class="{'is-hidden': updateHide}"
            @click="hadnleHideAndShow('updateHide', 'updateProject')"
          ></i>
          <p>最近更新项目</p>
        </div>
        <div class="content-wrap">
          <Nothing
            v-if="!updateProjectList.length"
            :config="{
              tip: '暂无最近更新项目'
            }"
          ></Nothing>
          <ul v-else class="update-project-content">
            <li
              v-for="item of updateProjectList"
              :key="item.project_id"
              @click="handleTo(item.project_id)"
            >
              <div class="item-left">
                <toolTip class="name" :title="item.title" :maxWidth="'92%'">
                  <span>{{item.title}}</span>
                </toolTip>
                <!-- <p class="name">{{ item.title }}</p> -->
                <span class="task-msgcount-super" v-if="item.msgcount">
                  {{ item.msgcount > 100 ? '99+' : item.msgcount }}
                </span>
              </div>
              <div class="item-right">
                <i
                  class="icon iconfont iconicon_following star-icon-con"
                  :class="isStar(item) ? 'star-icon' : 'no-star-icon'"
                ></i>
                <span class="task-num">
                  {{ item.completed_number_of_tasks }}
                  <em>/ {{ item.total_number_of_tasks }}</em>
                </span>
              </div>
            </li>
          </ul>
        </div>

      </div>
      <div class="history-project-wrap collapse-item" ref="historyProject">
        <div class="top">
          <i
            class="icon iconfont iconicon_arrow_task activeIconHover"
            :class="{'is-hidden': historyHide}"
            @click="hadnleHideAndShow('historyHide', 'historyProject')"
          ></i>
          <p>最近访问项目</p>
        </div>
        <div class="content-wrap">
          <Nothing
            v-if="!historyProjectList.length"
            :config="{
              tip: '暂无最近访问项目'
            }"
          ></Nothing>
          <ul v-else class="history-project-content">
            <li
              v-for="item of historyProjectList"
              :key="item.project_id"
              @click="handleTo(item.project_id)"
            >
              <div class="item-left">
                <toolTip class="name" :title="item.title" :maxWidth="'92%'">
                  <span>{{item.title}}</span>
                </toolTip>
                <!-- <p class="name">{{ item.title }}</p> -->
                <span class="task-msgcount-super" v-if="item.msgcount">
                  {{ item.msgcount > 100 ? '99+' : item.msgcount }}
                </span>
              </div>
              <div class="item-right">
                <i
                  class="icon iconfont iconicon_following star-icon-con"
                  :class="isStar(item) ? 'star-icon' : 'no-star-icon'"
                ></i>
                <span class="task-num">
                  {{ item.completed_number_of_tasks }}
                  <em>/ {{ item.total_number_of_tasks }}</em>
                </span>
              </div>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
//api
import api from '@/services/api/home/home'
//components
import Nothing from '@/components/nothing'
import ProjectItem from '../project/projectItem.vue'
import vuedraggable from 'vuedraggable'

export default {
  name: 'starProject',
  components: {
    Nothing,
    ProjectItem,
    vuedraggable
  },
  data() {
    return  {
      form: {
        page: 1,
        number: 10
      },
      starProjectList: [],
      updateProjectList: [],
      historyProjectList: [],
      loadVisibile: true,
      starHide: false, //星标内容是否折叠
      updateHide: false, //更新内容是否折叠
      historyHide: false //访问内容是否折叠
    }
  },
  created() {
    this.getStarList() //初始化获取星标项目列表
    this.getUpdateList() //初始化获取项目更新列表
    this.getHistoryList() //初始化获取访问列表
  },
  methods: {
    load() {
      if (this.loadVisibile) {
        this.form.page += 1
        this.getStarList() //初始化获取星标项目列表
      }
    },
    getStarListReset() {
      this.starProjectList = []
      this.form.number = this.form.page * 10
      this.form.page = 1
      this.getStarList()
      this.getUpdateList() // 获取项目更新列表
      this.getHistoryList() // 获取访问列表
    },
    async getStarList() {
      const res = await api.getprojectMarkStarList(this.form)
      if (res) {
        // console.log(res, 1111)
        this.$nextTick(() => {
          // for(let i = 0, len = res.data.length; i < len; i++) {
          //   this.starProjectList.push(res.data[i])
          //   this.starProjectList[i].member = res.data[i].project_members
          // }
          if (res.data.length < this.form.number) {
            this.loadVisibile = false
          }
          this.starProjectList.push(...res.data)
        })
      }
    },
    async getUpdateList() {
      const res = await api.getRecentUpdateProjectList()
      if (res) {
        // console.log(res, 1111)
        this.$nextTick(() => {
          this.updateProjectList = res.data
        })
      }
    },
    async getHistoryList() {
      const res = await api.getProjectBrowseHistoryList()
      if (res) {
        // console.log(res, 1111)
        this.$nextTick(() => {
          this.historyProjectList = res.data
        })
      }
    },
    //点击跳往项目
    handleTo(id) {
      this.$router.push({
        path: "/task",
        query: {
          projectId: id,
          isTabShow: true
        }
      })
    },
    //判断是否有标星
    isStar(item) {
      return item.project_mark_star ? item.project_mark_star.is_mark ? true : false : false
    },
    //折叠展开方法
    hadnleHideAndShow(val, doc) {
      const _icon = this.$refs[doc].querySelector('.top i') //获取对应的icon的dom
      const _content = this.$refs[doc].querySelector('.content-wrap')
      // console.log(this[val],_icon, 111111)
      if (this[val]) {
        //为true时，证明为折叠状态，点击需展开
        this[val] = false
        const _idx = _icon.className.indexOf('is-hidden')
        _icon.className = _icon.className.substr(0, _idx - 1)

        _content.style.display = 'block'
      } else {
        //点击需折叠
        this[val] = true
        _icon.className += ' is-hidden'

        _content.style.display = 'none'
      }
    },
    dragOptions() {
      return {
        animation: 200,
        group: 'list'
      }
    },
    async end(event) {
      let project_id = event.item.dataset.id * 1;
      let index = this.starProjectList.findIndex(res => res.project_id == project_id)
      let previous_project_id = index - 1 < 0 ? 0 : this.starProjectList[event.newIndex - 1].project_id
      let params = {
        project_id,
        previous_project_id,
      };
      await api.updateProjectMarkStarSort(params)
      this.$message({
        message: '修改成功',
        type: 'success',
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.star-project-container {
  padding: 17px 40px;
  .collapse-item {
    &.star-project-wrap {
      .star-project-content {
        position: relative;
        &.no-item {
          min-height: 254px;
        }
        .star-project-box {
          display: flex;
          flex-wrap: wrap;
          padding-bottom: 10px;
          .project-item {
            margin: 20px 16px 0 0;
          }
        }
      }
    }
    .top {
      width: 100%;
      height: 38px;
      padding: 8px 0;
      border-bottom: 1px solid rgba(231, 232, 237, 0.60);
      display: flex;
      align-items: center;
      i {
        font-size: 14px;
        margin-right: 4px;
        transition: transform .3s;
        cursor: pointer;
        &.is-hidden {
          transform: rotate(-90deg);
        }
      }
      p {
        font-size: 14px;
        font-weight: bold;
        color: #0D1F3C;
      }
    }
    .content-wrap {
      will-change: height;
    }
    ::v-deep .nothing-box {
      .imgs img {
        width: 123px;
      }
      .tip {
        margin: 14px 0 0 0;
      }
    }
  }
  .update-history-project-wrap {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    .collapse-item {
      flex: 1;
      &.update-project-wrap  {
        margin-right: 110px;
      }
      .content-wrap {
        position: relative;
        min-height: 280px;
      }
      ul {
        li {
          width: 100%;
          height: 54px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-bottom: 1px solid rgba(231, 232, 237, 0.60);
          cursor: pointer;
          padding: 0 24px;
          box-sizing: border-box;
          &:hover {
            background: rgba(32, 32, 32, 0.04);
          }
          &:active {
            background: #EAEBEC;
          }
          .item-left {
            display: flex;
            align-items: center;
            flex: 1;
            width: 0;
            .name {
              font-size: 14px;
              color: #0D1F3C;
              margin-right: 10px;
            }
             .task-msgcount-super {
              position: initial;
              margin-left: 8px;
              flex-shrink: 0;
            }
          }

          .item-right {
            display: flex;
            align-items: center;
            height: 16px;
            margin-left: 48px;
            i {
              font-size: 14px;
              margin-right: 20px;
              &.star-icon {
                color: #FFBE23;
              }
              &.no-star-icon {
                visibility: hidden;
                color: rgba(13, 31, 60, 0.24);
              }
            }
            .task-num {
              width: 51px;
              text-align: right;
              font-size: 12px;
              line-height: 16px;
              color: rgba(32, 32, 32, 0.6);
              min-width: 60px;
              text-align: right;
              em {
                color: rgba(13, 31, 60, .4);
              }
            }
          }
        }
      }
    }
  }
}
</style>
